import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Restablecer from "@/pages/Restablecer";
import AppShell from "@/layouts/AppShell";
import Escribir from "@/pages/Escribir";
import Habitos from "@/pages/Habitos";
import MiMes from "@/pages/MiMes";
import MiCuenta from "@/pages/MiCuenta";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";
import Instalar from "@/pages/Instalar";
import { OfflineScreen } from "@/components/OfflineScreen";
import { PublicLegal } from "@/components/PublicLegal";
import { ConsentScreen } from "@/components/ConsentScreen";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen bg-papel flex items-center justify-center text-sm text-meta" data-testid="auth-loading">Abriendo tu diario…</div>;
  }
  if (!user) return <Navigate to="/entrar" replace />;
  if (user.consent_needed) return <ConsentScreen />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/entrar" element={<Login />} />
      <Route path="/restablecer" element={<Restablecer />} />
      <Route path="/offline" element={<OfflineScreen />} />
      <Route path="/legal/privacidad" element={<PublicLegal><Privacidad /></PublicLegal>} />
      <Route path="/legal/terminos" element={<PublicLegal><Terminos /></PublicLegal>} />
      <Route element={<Protected><AppShell /></Protected>}>
        <Route path="/escribir/:entryId?" element={<Escribir />} />
        <Route path="/habitos" element={<Habitos />} />
        <Route path="/mi-mes" element={<MiMes />} />
        <Route path="/mi-cuenta" element={<MiCuenta />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/instalar" element={<Instalar />} />
      </Route>
      <Route path="*" element={<Navigate to="/escribir" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
